import { AVANTAGE_SOCIAL_REQUESTS_SUCCESS, AVANTAGE_SOCIAL_REQUESTS_FAILURE, SET_AVANTAGE_SOCIAL_REQUESTS_LOADING } from "../actions/avantageSocialRequestActions";
const initialState = { loading: false, error: null, myRequests: [], managerInbox: [], adminInbox: [] };
export default function avantageSocialRequestReducer(state = initialState, action) {
    switch (action.type) {
        case SET_AVANTAGE_SOCIAL_REQUESTS_LOADING: return { ...state, loading: action.payload };
        case AVANTAGE_SOCIAL_REQUESTS_SUCCESS: return { ...state, loading: false, error: null, [action.payload.scope]: action.payload.data || [] };
        case AVANTAGE_SOCIAL_REQUESTS_FAILURE: return { ...state, loading: false, error: action.payload };
        default: return state;
    }
}
